export default __webpack_public_path__ + "static/11_19-4055f15ac30a269be5c3b930082448fc.png";